<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" :disabled="getMessagesCurrentUser.length === 0">
          <v-icon>message</v-icon>
          <StandardBadge
            v-if="getMessagesCurrentUser.length !== 0"
            :zoom="1"
            :text="getMessagesCurrentUser.length"
            color="white"
            content_color="black"
          />
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="message in getMessagesCurrentUser.slice(0, 5)"
          :key="message.id"
          @click="readMessageAndRoute(message)"
        >
          <v-list-item-action>
            <v-icon v-if="message.type === 'notification'">notifications</v-icon>
            <v-icon v-if="message.type === 'warning'">warning</v-icon>
          </v-list-item-action>
          <v-list-item-title class="message-preview" style="margin-left: -25px">{{ message.text }}</v-list-item-title>
        </v-list-item>
        <v-list-item :to="{name: 'AccountMessages'}">
          <v-list-item-action>
            <v-icon>messages</v-icon>
          </v-list-item-action>
          <v-list-item-title style="margin-left: -25px">See {{getMessagesCurrentUser.length-5}} more...</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">
          <v-avatar color="grey" size="32">
            <span v-if="getUser.image==='noimage'" class="white--text headline">
              {{getUser.first_name[0].toUpperCase() + getUser.last_name[0].toUpperCase()}}
            </span>
            <v-img v-if="getUser.image!=='noimage'" height="100%" :src="getUser.image">
            </v-img>
          </v-avatar>
          <v-icon>keyboard_arrow_down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item :to="{name: 'AccountInfo'}">
          <v-list-item-action>
            <v-icon>account_box</v-icon>
          </v-list-item-action>
          <TText style="margin-left: -25px" value="Account" :font_weight="400"/>

        </v-list-item>
        <v-list-item :to="{name: 'AccountMessages'}">
          <v-list-item-action>
            <v-icon>messages</v-icon>
          </v-list-item-action>
          <TText style="margin-left: -50px" value="Messages" :font_weight="400"/>

        </v-list-item>
        <v-list-item :to="{name: 'GeneralSettings'}">
          <v-list-item-action>
            <v-icon>settings</v-icon>
          </v-list-item-action>
          <TText style="margin-left: -25px" value="General_Settings" :font_weight="400"/>

        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-action>
            <v-icon>power_settings_new</v-icon>
          </v-list-item-action>
          <TText style="margin-left: -25px" value="Logout" :font_weight="400"/>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue'
import TText from '@/components/Taktify/TText.component.vue'


import {
  mapGetters, mapActions
} from 'vuex';
export default {
  components: {StandardBadge, TText},
  computed: {
    ...mapGetters('Auth', [
      'getUser'
    ]),
    ...mapGetters('Message', [
      'getMessagesCurrentUser'
    ])
  },
  methods: {
    ...mapActions('Message', [
      'requestMarkMessageAsRead'
    ]),
    logout() {
      this.$store.dispatch('Auth/logout', {});
    },
    getMessageRoute(msg){
      // if (msg.twork_packages.length) {
        // return {
        //   name: 'TaktPlanWorkPackageMessageBoard',
        //   params: {
        //     project_id: msg.twork_packages[0].project_id,
        //     train_id: msg.twork_packages[0].train_id,
        //     taktarea_id: msg.twork_packages[0].taktarea_id,
        //     twaggon_id: msg.twork_packages[0].twaggon_id,
        //     tworkpackage_id: msg.twork_packages[0].id
        //   }
        // };
      // } else {
        return {
          name: 'ProjectMessageBoard',
          params: {
            project_id: msg.projects[0].id,
          }
        };
      // }
    },
    readMessageAndRoute(message){
      let self = this;
      this.requestMarkMessageAsRead({ message_id: message.id }).then( () => {
        self.$router.push(self.getMessageRoute(message));
      });
    }
  },
}
</script>
<style>
.message-preview {
  width: 300px;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
</style>
